module.exports = __webpack_public_path__ + "img/dashboard_available_credit.cf812f7.png";